import io from "socket.io-client"

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE

let socket
if (role === "sender") {
  socket = io(url)
}

const setActiveLights = apartments => {
  /**
   * Pass a list of apartments by their Ref (E1.01.01 etc.) to turn them on, and
   * all other lights off.
   *
   * The system will also respond to things like 'E.Retail' to turn on the
   * retail lights in block E, or 'All' to turn on all lights.
   */

  if (role === "sender") {
    console.log("ON:", apartments)
    socket.emit("lights", apartments)
  }
}

export const TurnLightsOff = apartments => {
  console.log(apartments)
  /**
   * Pass a list of apartments by their Ref (E1.01.01 etc.) to turn them on, and
   * all other lights off.
   *
   * The system will also respond to things like 'E.Retail' to turn on the
   * retail lights in block E, or 'All' to turn on all lights.
   */

  if (role === "sender") {
    console.log("ON:", apartments)
    socket.emit("lights", [])
  }
}

export default setActiveLights
